import { Command } from 'cmdk'
import { useEffect, useState } from 'react'
import { useRouter } from 'next/navigation'

const ROUTES = [
  { name: 'Home', path: '/' },
  { name: 'Accounts', path: '/accounts' },
  { name: 'Leads', path: '/leads' },
  { name: 'Contacts', path: '/contacts' },
  { name: 'Opportunities', path: '/opportunities' },
]

const FORM_SHORTCUTS = [
  {name: 'Save', key: 'S'},
  {name: 'Cancel', key: 'X'},
  {name: 'Edit', key: 'E'}
]

export function CommandPalette() {
  const [open, setOpen] = useState(false)
  const router = useRouter()

  useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (e.key === 'k' && (e.metaKey || e.ctrlKey)) {
        e.preventDefault()
        setOpen((open) => !open)
      }
    }

    document.addEventListener('keydown', down)
    return () => document.removeEventListener('keydown', down)
  }, [])

  if (!open) return null

  return (
    <div className="fixed inset-0 z-50">
      <div className="fixed inset-0 bg-black/50" />
      <Command.Dialog
        open={open}
        onOpenChange={setOpen}
        label="Global Command Menu"
        className="fixed left-1/2 top-[20%] z-50 w-[640px] max-w-[90vw] -translate-x-1/2 transform rounded-xl border border-gray-200 bg-white p-2 shadow-2xl"
      >
        <Command.Input 
          placeholder="Search for pages and commands..." 
          className="w-full border-none bg-transparent px-4 py-3 text-gray-800 outline-none placeholder:text-gray-400"
        />
        <Command.List className="mt-2 max-h-[300px] overflow-y-auto">
          <Command.Empty className="py-6 text-center text-sm text-gray-500">
            No results found.
          </Command.Empty>

          {/* <Command.Group heading="Form" className='px-2 py-1 text-xs font-semibold text-gray-500'>
            {FORM_SHORTCUTS.map((s) => (
              <Command.Item key={s.key} className='flex cursor-pointer items-center rounded-md px-4 py-2 text-sm text-gray-800'>
                {s.name}
              </Command.Item>
            ))}
          </Command.Group> */}

          <Command.Group heading="Navigation" className="px-2 py-1 text-xs font-semibold text-gray-500">
            {ROUTES.map((route) => (
              <Command.Item
                key={route.path}
                onSelect={() => {
                  router.push(route.path)
                  setOpen(false)
                }}
                className="flex cursor-pointer items-center rounded-md px-4 py-2 text-sm text-gray-800 hover:bg-gray-100 data-[selected=true]:bg-gray-100"
              >
                {route.name}
              </Command.Item>
            ))}
          </Command.Group>
        </Command.List>
      </Command.Dialog>
    </div>
  )
}
